export default __webpack_public_path__ + "static/media/Fishing Dad Son Poles.bd8b17f1.jpeg";